import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { tipologieDocumentoApi } from '../../services/api'
import { RedTipologiaDocumentoCustom } from '../../types/red'

interface Props {
  onClose: () => void
  onCreated: (tipo: RedTipologiaDocumentoCustom) => void
}

const NuovaTipologiaDocumentoModal: React.FC<Props> = ({ onClose, onCreated }) => {
  const [nome, setNome] = useState('')
  const [saving, setSaving] = useState(false)

  const handleSalva = async () => {
    if (!nome.trim()) {
      toast.error('Il nome è obbligatorio')
      return
    }
    setSaving(true)
    try {
      const res = await tipologieDocumentoApi.create(nome.trim())
      toast.success('Tipologia creata')
      onCreated(res.data)
      onClose()
    } catch (err: any) {
      toast.error(err?.response?.data?.detail || 'Errore creazione tipologia')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => !saving && onClose()}>
      <div className="bg-white rounded-xl p-6 max-w-sm w-full" onClick={e => e.stopPropagation()}>
        <h3 className="text-lg font-semibold mb-1">Nuova tipologia documento</h3>
        <p className="text-sm text-gray-500 mb-4">Comparirà nel menu Tipologia insieme a quelle esistenti.</p>
        <label className="label text-xs">Nome</label>
        <input
          className="input"
          value={nome}
          onChange={e => setNome(e.target.value)}
          placeholder="Es. Verbale di collaudo"
          autoFocus
        />
        <div className="flex gap-2 mt-4">
          <button onClick={handleSalva} disabled={saving} className="btn-primary text-sm">
            {saving ? 'Creazione...' : 'Crea tipologia'}
          </button>
          <button onClick={onClose} disabled={saving} className="text-sm text-gray-500">Annulla</button>
        </div>
      </div>
    </div>
  )
}

export default NuovaTipologiaDocumentoModal
